import { useEffect, useMemo } from 'react';
import useClient from './useClient';

export const useBankAccountEnding = () => {
  const { client, fetchClient, fetching } = useClient();

  useEffect(() => {
    if (client || fetching) return;
    fetchClient();
  }, [client, fetching]);

  return useMemo(
    () => client?.bankAccount?.slice(-4) || 'XXXX',
    [client?.bankAccount],
  );
};
